<template>
	<error-card :message="$t('Page not found')" :code="code" />
</template>
<script>
import ErrorCard from './ErrorCard';
export default {
	name: 'NotFound',
	components: {
		ErrorCard
	},
	data() {
		return { code: 1001 };
	}
};
</script>
